import React, { memo } from "react";
import { Box, Card, CardBody, CardFooter, CardHeader, HStack, Text, VStack } from "@chakra-ui/react";
import { CircularLoading } from "../../molecules/loading/CircularLoading";
import { PageTransitionBtn } from "../../atoms/button/PageTransitionBtn";
import { useFetchSoCouponSurveySelectedQuestionsByRestaurantId } from "../../../hooks/socoupon/useFetchSoCouponSurveySelectedQuestionsByRestaurantId";
import { useParams } from "react-router-dom";
import { DarkShadowCard } from "../../molecules/card/DarkShadowCard";
import { CardHeading } from "../../molecules/card/CardHeading";
import { RiFileTextLine } from "react-icons/ri";


export const SoCouponSurveySelectedQuestions: React.FC = memo(() => {
  const { restaurantId } = useParams()
  const { selectedQuestions, isLoading } = useFetchSoCouponSurveySelectedQuestionsByRestaurantId(restaurantId)
  if (isLoading) return <CircularLoading />
  return (
    <Box m='auto' w={{ base: '100%', md: '80%', lg: '600px' }}>
      <DarkShadowCard>
        <CardHeader>
          <CardHeading icon={<RiFileTextLine size="20px" />} heading='使用中アンケート質問'/>
        </CardHeader>
        <CardBody py={2}>
          <VStack spacing={3}>
            {selectedQuestions?.map((selectedQuestion) => (
              <Card key={selectedQuestion.id} rounded='2xl' w='100%' >
                <CardBody p={3}>
                  <HStack fontSize='sm' fontWeight='bold' spacing={3}>
                    <Text m={0}>Q{selectedQuestion.order}</Text>
                    <Text m={0}>{selectedQuestion.question_content}</Text>
                  </HStack>
                </CardBody>
              </Card>
            ))}
          </VStack>
        </CardBody>
        <CardFooter>
          <PageTransitionBtn path={'edit'} text="編集" />
        </CardFooter>
      </DarkShadowCard>
    </Box>
  );
});